module.exports = __webpack_public_path__ + "static/media/S3_03.b70ca017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE3strobe/S3_03.png
// module id = 197
// module chunks = 0